<template>
  <v-card :key="mode">
    <v-card-text v-if="object">
      <v-form>
        <v-container>
          <v-card outlined style="border: 1px solid #1976d2;">
            <div bottom class="text-h6">Datos Generales</div>
            <!-- Fila 1 -->
            <v-row dense>
              <v-col cols="3">
                <v-text-field
                  hide-details
                  label="Fecha"
                  id="date"
                  v-model="object.date_formatted"
                  disabled
                />
              </v-col>
              <v-col>
                <v-text-field
                  disabled
                  hide-details
                  v-show="editing === false"
                  label="Agente"
                  :value="object.dealer_code + ' - ' + object.dealer_name"
                >
                </v-text-field>
                <v-autocomplete
                  v-show="editing === true"
                  :disabled="!editing"
                  label="Agente"
                  :items="settlementRequestDealerItems"
                  :loading="settlementRequestIsLoadingDealer"
                  hide-details
                  hide-no-data
                  hide-selected
                  :item-text="getDealerText"
                  v-model="settlementRequestSelectedDealer"
                  item-value="dealer"
                  return-object
                  @change="dealerChange($event)"
                  ref="dealerAutocomplete"
                >
                  <!-- eslint-disable -->
                  <v-icon
                    slot="prepend"
                    :disabled="!editing || !object.dealer"
                    :class="
                      editing && object.dealer
                        ? 'enabled-icon'
                        : 'disabled-icon'
                    "
                    @click="clearAutocomplete('dealerAutocomplete')"
                  >
                    mdi-close
                  </v-icon>
                  <!-- eslint-enable -->
                </v-autocomplete>
              </v-col>
            </v-row>
            <!-- Fila 2 -->
            <v-row dense>
              <v-col>
                <v-text-field
                  disabled
                  hide-details
                  label="Comisión Total USD"
                  type="number"
                  :value="object.total_commission_usd"
                />
              </v-col>
              <v-col>
                <v-text-field
                  disabled
                  hide-details
                  label="Cotización USD"
                  type="number"
                  :value="object.usd_value"
                />
              </v-col>
              <v-col>
                <v-text-field
                  disabled
                  hide-details
                  label="Fecha Cotización"
                  :value="object.usd_rate_date_formatted"
                />
              </v-col>
              <v-col>
                <v-text-field
                  disabled
                  hide-details
                  label="Comisión Total PES"
                  type="number"
                  :value="object.total_commission_lc"
                />
              </v-col>
              <v-col>
                <v-text-field
                  disabled
                  hide-details
                  label="Registración"
                  v-model="object.backend_code"
                />
              </v-col>
            </v-row>
            <!-- Fila 3 -->
            <!-- Adjunto -->
            <v-file-input
              v-show="editing"
              v-model="object.invoice_file"
              accept=".pdf"
              :label="fileInputLabel"
              :rules="[fileInputValidation]"
            ></v-file-input>
            <!-- Fila 4 -->
            <v-row dense>
              <v-col>
                <v-textarea
                  :disabled="!editing"
                  hide-details
                  clearable
                  label="Texto"
                  v-model="object.comments"
                  rows="1"
                  auto-grow
                />
              </v-col>
            </v-row>
          </v-card>
          <!-- Items -->
          <v-row dense>
            <v-col colse="12">
              <div class="table-footer-prepend d-flex pl-2 align-center">
                <v-tooltip top>
                  <template v-slot:activator="{ activationEvents }">
                    <v-btn
                      icon
                      :disabled="!editing"
                      outlined
                      color="primary"
                      v-on="activationEvents"
                      @click="saleCommissionSearchClick"
                    >
                      <v-icon
                        :class="editing ? 'enabled-icon' : 'disabled-icon'"
                      >
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar</span>
                </v-tooltip>
              </div>
              <v-data-table
                dense
                :headers="settlementRequestItemsHeaders"
                :items="object.settlement_request_items"
              >
                <!-- pagination template -->
                <template v-slot:top="{ pagination, options, updateOptions }">
                  <v-data-footer
                    :pagination="pagination"
                    :options="options"
                    @update:options="updateOptions"
                  />
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    v-show="editing"
                    small
                    class="mr-2"
                    @click.stop="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>

    <!-- component for magnify searchs -->
    <sale-commission-search-dialog
      v-if="settlementRequestShowSearch"
      :show="settlementRequestShowSearch"
      :title="settlementRequestSearchOptions.title"
      :endpoint="settlementRequestSearchOptions.endpoint"
      :ordering="settlementRequestSearchOptions.ordeting"
      :searchLabel="settlementRequestSearchOptions.searchLabel"
      :headers="settlementRequestSearchOptions.headers"
      :filterString="settlementRequestSearchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      :searchOnURL="settlementRequestSearchOptions.searchOnURL"
      :initialItemsPerPage="settlementRequestSearchOptions.initialItemsPerPage"
      :selectedItems="settlementRequest.getSelectedItems(object)"
      @cancel="searchCanceled"
      @itemsSelected="searchSelected($event)"
    >
    </sale-commission-search-dialog>
  </v-card>
</template>
<script>
import DataSettlementRequest from "@/components/clon/DataSettlementRequest.js";
import SaleCommissionSearchDialog from "@/components/SaleCommissionSearchDialog.vue";

export default {
  name: "SettlementRequestEdit",

  components: {
    SaleCommissionSearchDialog
  },

  props: ["value", "initialmode"],

  data() {
    return {
      object: null,
      current_level: null,
      editing: false,
      mode: null,
      settlementRequest: new DataSettlementRequest(this.$bRoot),
      settlementRequestShowSearch: null,
      settlementRequestItemIndex: null,
      settlementRequestSearchOptions: null,
      settlementRequestIsLoadingDealer: null,
      settlementRequestDealerItems: [],
      settlementRequestFilterItem: null,
      settlementRequestFilterDealer: null,
      settlementRequestSelectedDealer: null,
      settlementRequestItemsHeaders: [
        {
          text: "Acciones",
          value: "actions",
          sortable: false
        },
        {
          text: "Item",
          value: "item_number",
          sortable: false,
          locked: true
        },
        {
          text: "Pedido",
          value: "sale_code",
          sortable: false,
          locked: true
        },
        {
          text: "Cliente",
          value: "client_name",
          sortable: false,
          locked: true
        },
        {
          text: "Factura/NC",
          value: "sale_invoice_code",
          sortable: false,
          locked: true
        },
        {
          text: "Comision USD",
          value: "commission_usd",
          sortable: false,
          align: "end"
        },
        {
          text: "Comision PES",
          value: "commission_lc",
          sortable: false,
          align: "end"
        }
      ],
      fileInputLabel: "Factura [*.pdf]"
    };
  },

  //this one will populate new data set when user changes current page.
  watch: {
    editing: {
      handler() {
        this.editingChange();
      }
    },
    deep: true
  },

  methods: {
    fileInputValidation(file) {
      this.object.fileError = null;
      if (this.object.dealer_object) {
        var sre =
          this.object.dealer_object.identification +
          "_FC_" +
          "[0-9]{4}\\-[0-9]{8}\\.pdf";
        var re = new RegExp(sre);
        if (file ? file.size : 0 > 0) {
          if (!re.test(file.name)) {
            this.object.fileError =
              "El nombre del archivo no respeta el formato [CUIT]_FC_[Punto Venta]-[Numero de Factura].pdf";
          } else if (file.size / 1024 > 200) {
            this.object.fileError =
              "El tamaño del archivo debe ser inferior a 200 KB";
          }
        }
      }
      if (this.object.fileError) {
        return this.object.fileError;
      } else {
        return true;
      }
    },

    async clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "dealerAutocomplete":
          this.settlementRequestFilterDealer = null;
          this.settlementRequestSelectedDealer = null;
          this.object = await this.settlementRequest.setDealer(this.object);
          break;
      }
    },

    async searchSelected(items) {
      this.$bRoot.errors = null;
      let added = null;
      try {
        added = await this.settlementRequest.itemsActualize(this.object, items);
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        if (added) {
          this.object = added;
        }
        this.searchCanceled();
      }
    },

    searchCanceled() {
      this.settlementRequestShowSearch = false;
      this.settlementRequestSearchOptions = {};
    },

    async loadDealers() {
      let endpoint = "/data/dealers_campaign_hierarchy/0";
      this.settlementRequestFilterDealer = null;
      this.settlementRequestDealerItems = [];
      this.settlementRequestIsLoadingDealer = true;
      let res = await this.$bRoot.searchAll(endpoint);
      this.settlementRequestDealerItems = res;
      this.settlementRequestIsLoadingDealer = false;

      /* set default value */
      let leader_id = null;
      let dealer_id = null;
      if (this.object.url) {
        dealer_id = this.object.dealer_id;
      } else {
        if (this.$bRoot.auth.current_level >= 3) {
          // eslint-disable-next-line
          leader_id = (this.$bRoot.auth.current_level === 3 ? this.$bRoot.appInfo.commercial_person.id : this.$bRoot.appInfo.commercial_person.superior_id);
        }
      }
      let index = -1;
      if (dealer_id) {
        index = res.findIndex(item => item.dealer_id === dealer_id);
        if (index !== -1) {
          this.settlementRequestSelectedDealer = res[index].dealer;
          this.settlementRequestFilterDealer = res[index];
          this.dealerSelected();
        }
      } else if (leader_id) {
        // eslint-disable-next-line
        let index = res.findIndex(item => item.commercial_person_id === leader_id);
        if (index !== -1) {
          this.settlementRequestSelectedDealer = res[index].dealer;
          this.settlementRequestFilterDealer = res[index];
          this.dealerChange(this.settlementRequestFilterDealer);
        }
      }
    },

    async dealerChange(dealer) {
      this.object = await this.settlementRequest.setDealer(
        this.object,
        dealer,
        null
      );
      this.dealerSelected();
    },

    async dealerSelected() {
      this.fileInputLabel =
        "Factura [" +
        this.object.dealer_object.identification +
        "_FC_0000-00000000.pdf]";
      this.object.invoice_file = [];
    },

    async deleteItem(item) {
      this.object = await this.settlementRequest.deleteItem(this.object, item);
    },

    getDealerText(item) {
      if (item) {
        return item.code + " - " + item.name;
      }
    },

    saleCommissionSearchClick() {
      if (!this.object.dealer) {
        this.$bRoot.setError("Seleccione Agente");
      } else {
        this.settlementRequestSearchOptions = {
          headers: [
            {
              text: "Pedido",
              value: "sale_code",
              sortable: false,
              locked: true
            },
            {
              text: "Cliente",
              value: "client_name",
              sortable: false,
              locked: true
            },
            {
              text: "Factura/NC",
              value: "sale_invoice_code",
              sortable: false,
              locked: true
            },
            {
              text: "Vencimiento",
              value: "sale_invoice_due_date_formatted",
              sortable: false,
              locked: true
            },
            {
              text: "Comision USD",
              value: "claimable_usd",
              sortable: false,
              locked: true,
              align: "end"
            }
          ],
          title: "Comisiones liquidables...",
          endpoint:
            "/data/sale_commissions/claimable/" +
            this.object.dealer_id.toString(),
          ordering: null,
          searchLabel: "Cliente/Comprobante",
          selected: "clientSelected",
          searchOnURL: false,
          initialItemsPerPage: 250
        };
        this.settlementRequestShowSearch = true;
      }
    },

    async save() {
      this.$bRoot.errors = null;
      let added = null;
      try {
        added = await this.settlementRequest.save(this.object, this);
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        if (added) {
          this.object = added;
          this.mode = "show";
          this.editing = false;
          this.$emit("endEdit", added);
        } else {
          this.$emit("actionCanceled", added);
        }
      }
    },

    async changeState(state_code) {
      this.$bRoot.errors = null;
      try {
        await this.settlementRequest.changeState(this.object, state_code);
        this.$emit("endEdit");
      } catch (error) {
        this.$emit("actionCanceled");
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      }
    },

    async editingChange() {
      let index = null;

      //delete header column
      index = this.settlementRequestItemsHeaders.findIndex(
        item => item.value === "delete"
      );
      if (this.editing) {
        if (index === -1) {
          this.settlementRequestItemsHeaders.splice(0, 0, {
            text: "",
            value: "delete",
            sorteable: false
          });
        }
      } else {
        if (index !== -1) {
          this.settlementRequestItemsHeaders.splice(index, 1);
        }
      }

      //In entering in edit mode load Dealers and Scales
      if (this.editing) {
        await this.loadDealers();
      }
    }
  },

  async mounted() {
    this.mode = this.initialmode;
    this.object = this.value;
    this.current_level = this.$bRoot.auth.current_level;

    this.editing = this.mode === "edit" || this.mode == "new";
  }
};
</script>
<style>
.inputCol input[type="number"] {
  -moz-appearance: textfield;
  text-align: right;
  width: 60px;
}
.inputCol input::-webkit-outer-spin-button,
.inputCol input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.enabled-icon {
  pointer-events: auto;
  color: black;
}
.disbled-icon {
  pointer-events: none;
}
</style>
